<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/ManageShopChangeRequest'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">จัดการขอแก้ไขข้อมูลร้านค้า</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="shcmKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก รหัส ชื่อร้านค้า เจ้าหน้าที่ดูแล โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อร้านค้า 1, ชื่อร้านค้า 2"
                  />
                </div>
              </div>
              <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                              <div class="form-group">
                                <label>พนักงาน :</label>
                                <select2
                                  :css-style="'width: 100%;'"
                                  :css-class="'form-control'"
                                  :id="'shcmEmpId'"
                                  :name="'shcmEmpId'"
                                  :multiple="true"
                                  :select2-options="shcmEmpIdOptions"
                                  v-model="shcmEmpId"
                                  ref="shcmEmpIdSelect2"
                                ></select2>
                              </div>
                            </div> -->
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shcmShopTypeId'"
                    :name="'shcmShopTypeId'"
                    :select2-options="shcmShopTypeIdOptions"
                    v-model="shcmShopTypeId"
                    ref="shcmShopTypeIdSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="shcmShopTypeId"
                    :multiple="true"
                    :clear-on-select="true"
                    :options="shcmShopTypeIdOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shcmProvinceId'"
                    :name="'shcmProvinceId'"
                    :select2-options="shcmProvinceIdOptions"
                    @selectChange="onAmpherIdChange"
                    v-model="shcmProvinceId"
                    ref="shcmProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shcmAmpherId'"
                    :name="'shcmAmpherId'"
                    :select2-options="shcmAmpherIdOptions"
                    v-model="shcmAmpherId"
                    ref="shcmAmpherIdSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shcmApproveStatus'"
                    :name="'shcmApproveStatus'"
                    :select2-options="shcmApproveStatusOptions"
                    v-model="shcmApproveStatus"
                    ref="shcmApproveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="shopChangeRequestTable"
              >
                <thead>
                  <tr>
                    <th class="all">รหัสร้านค้า</th>
                    <th class="all">ชื่อร้านค้า</th>
                    <th class="all">ชื่อร้านค้า 2</th>
                    <th class="all">ประเภทร้านค้า</th>
                    <th class="all">ผู้ร้องขอแก้ไข</th>
                    <th class="all">วันที่ส่งคำขอ</th>
                    <!-- <th class="all">อำเภอ</th>
                                        <th class="all">จังหวัด</th> -->
                    <!-- <th class="all">Old Latitude</th>
                                        <th class="all">Old Longitude</th>
                                        <th class="all">New Latitude</th>
                                        <th class="all">New Longitude</th> -->
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="detail" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
  </div>`,
  methods: {
    detail: function() {
      router.push({
        path: `/Master/ManageShopChangeRequest/Detail/${this.data.customerChangeRequestId}`,
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      shcmKeyword: null,
      shcmApproveStatus: null,
      shcmEmpId: null,
      shcmShopTypeId: [],
      shcmProvinceId: null,
      shcmAmpherId: null,
      shcmShopTypeIdOptions: [],
      //config
      // shcmShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ShopType/Select2SearchShopType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      shcmProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      shcmAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.shcmProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      shcmEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      shcmApproveStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "APPROVE_CHANGE_REQUEST_STATUS",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.shcmKeyword = "";
      this.shcmShopTypeId = [];
      $("#shcmApproveStatus")
        .val("")
        .trigger("change");

      $("#shcmShopTypeId")
        .val("")
        .trigger("change");

      $("#shcmProvinceId")
        .val("")
        .trigger("change");

      $("#shcmAmpherId")
        .val("")
        .trigger("change");

      $("#shcmEmpId")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#shopChangeRequestTable").DataTable();
      table.search(this.id | this.name);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#shopChangeRequestTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    onAmpherIdChange: function() {
      $("#shcmAmpherId")
        .val("")
        .trigger("change");
    },
    LoadShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shcmShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    self.LoadShopTypeIdOptions();
    var table = $("#shopChangeRequestTable");
    $.fn.dataTable.ext.errMode = 'none';
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/ShopChangeRequest/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.shcmKeyword,
                ShopTypeId: self.shcmShopTypeId,
                ProvinceId: self.shcmProvinceId,
                AmpherId: self.shcmAmpherId,
                Status: self.shcmApproveStatus,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[5, "desc"]],
        columns: [
          { data: "customerCode", className: "text-center",
            render: function(data, type, full, meta) {
              return full.custCode;
            }, 
          },
          { data: "customerName", className: "text-center" },
          { data: "customerName2", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "employeeFullName", className: "text-center" },
          {
            data: "createDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.createDateStringFormat2;
            },
          },
          // { data: "ampherName", className: "text-center" },
          // { data: "provinceName", className: "text-center" },
          { data: "statusValue", className: "text-center" },
          {
            data: "customerChangeRequestId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_SHOPPROFILE",
              "ADMIN_MKT",
              "ADMIN_PM",
              "ADMIN_QI",
              "MANAGER_MKT",
              "USER_QI",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/ShopChangeRequest/ManageShopChangeRequest.vue